import { render, staticRenderFns } from "./licenseexpiHis.vue?vue&type=template&id=1f416a83&scoped=true"
import script from "./licenseexpiHis.vue?vue&type=script&lang=js"
export * from "./licenseexpiHis.vue?vue&type=script&lang=js"
import style0 from "./licenseexpiHis.vue?vue&type=style&index=0&id=1f416a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f416a83",
  null
  
)

export default component.exports